module.exports = {"available":"Ledig","booked":"Booket","occupied":"Okkupert","booked-occupied":"Booket / Okkupert","used":"brukt","until":"til","all-day":"hele dagen","page_over_total":"Side {page} av {total}","room-name":"ROM","current-booking":"NÅ","next-booking":"NESTE","unknown":"Ukjent","floors":"Etasje","today":"i dag","no_bookings":"Ingen planlagte møter i dag","no_information":"Ingen informasjon tilgjengelig","description":"Beskrivelse","capacity":"Kapasitet","allocated":"Gitt","booked-occupied-allocated":"Booket / Okkupert / Gitt"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/nb.json
// module id = DS4F
// module chunks = 2